import { render, staticRenderFns } from "./booking-new.vue?vue&type=template&id=52766ed9&"
import script from "./booking-new.vue?vue&type=script&lang=js&"
export * from "./booking-new.vue?vue&type=script&lang=js&"
import style0 from "./booking-new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports